(function($, undefined) {

	'use strict';
	var formValidator;
	var filtersForm;
	var scrollTopBtn;
	var validateFormBtn;
	var toggleTriggerBtn;
	var toggleTriggerVal;
	var toggleTriggerInput;
	var submitFormBtn;
	var numbersOnlyInput;
	var priceOnlyInput;
	var settingsInput;
	var bgPosRange;
	var toggleSettingsBtn;
    
    var refresh = function() {
        window.location.reload();
    };

	var submitForm = function() {
		if (!$(this).hasClass('no-disable')) {
			$(this).addClass('disabled');
		}
		$(this).closest('form').submit();
	};

	var submitMultiFilter = function() {
		var t = $(this);
		var val = t.val();

		if (val === '') {
            window.location.href = t.attr('data-extra');
		} else {
			var option = t.find('option[value=' + val + ']');
			var search = option.attr('data-search');
			var search2 = option.attr('data-search2');
			var url = t.attr('data-extra');

			if (t.attr('data-extra').indexOf('?') === -1) {
				url += '?';
			} else if (t.attr('data-extra').indexOf('&') !== -1 || t.attr('data-extra').indexOf('?') !== -1) {
				url += '&';
			}

            if (search === undefined || search === '') {
                search = option.parent()[0].name + '=' + val;
			}
            url += search;
            
			if (search2 !== undefined && search2 !== '') {
                url += '&' + search2;
			}

			window.location.href = url;
		}
	};

	var ignoreUnusedStates = function(form) {
		var states = form.find('.select-state-input-ctn');
		if (states.length) {
			states.each(function() {
                var state = $(this);
                if (state.find('.fake-input').length) {
                    // Do nothing. The "fake-input" class is a way to make the input non required.
                } else if (state.css('display') === 'none') {
					state.find('.form-input').removeClass('required').addClass('derequired');
				} else if (state.css('display') === 'block') {
					state.find('.form-input').removeClass('derequired').addClass('required');
				}
			});
		}
	};

	var validateForm = function(t) {
		var btn;
		if (t.length) {
			btn = t;
		} else {
			btn = $(this);
		}
		var form = btn.closest('form');

		ignoreUnusedStates(form);
		formValidator.validateForm(form);
        
		if (!form.hasClass('has-error')) {
			if (form.find('.remove-on-submit').length) {
				form.find('.remove-on-submit').each(function() {
					if ($(this).css('display') === 'none') {
						$(this).remove();
					}
				});
			}

			btn.addClass('disabled');
			form.submit();
		}
	};

	var ajaxValidateFormAndReload = function(t) {
		var btn;
		if (t.length) {
			btn = t;
		} else {
			btn = $(this);
		}
		var form = btn.closest('form');

		ignoreUnusedStates(form);
		formValidator.validateForm(form);
        
		if (!form.hasClass('has-error') && !btn.hasClass('disabled')) {
			btn.addClass('disabled');
            
            var data, forward, settings;
            
            settings = {
                url: form.attr('action'),
                method: form.attr('method').toUpperCase(),
                type: form.attr('method'),
                cache: false,
                processData: false,
                complete: function(xhr, status) {
                    // No matter success or error
                    if (forward) {
                        window.location.href = forward;
                    } else {
                        window.location.reload();
                    }
                }
            };
            
            if (form.attr('enctype') === 'multipart/form-data') {
                settings.contentType = 'multipart/form-data';
                data = new FormData(form[0]);
                data.append('ajax', 'true');
                forward = data.get('pageName') || data.get('pageSuccess');
            } else {
                data = form.serialize() + "&ajax=true";
                forward = form.find('[name="pageName"],[name="pageSuccess"]').val();
            }
            settings.data = data;
            
			$.ajax(settings);
            if (btn.hasClass('open-loading-popup')) {
                $('.popup-outer[data-id="loadingWait"]').addClass('open');
            }
		}
	};

	var scrollUp = function() {
		$('html').animate({scrollTop: 0}, 300);
		$('body').animate({scrollTop: 0}, 300);
	};

	var toggleElement = function(e) {
		var t = $(this);
        var togId = t.attr('data-toggle-id');
		var ctn = t.closest('.toggle-outer-ctn');
		var el = t.hasClass('first-level-toggle') ? ctn.children('.element-to-toggle') : ctn.find('.element-to-toggle');
        var togglers = ctn.find('.toggle-trigger-element.required');
        var closeAll = t.hasClass('close-all');
        var elIsClosed = el.css('display') === 'none';

		if (closeAll) {
			ctn.find('.element-to-toggle').slideUp();
            t.removeClass('toggled');
		}
        
        setTimeout(function() {
            if (t.attr("data-hide-elements")) {
                $(t.attr("data-hide-elements"), ctn).hide();
            }
            if (t.attr("data-show-elements")) {
                $(t.attr("data-show-elements"), ctn).show();
            }
        }, elIsClosed ? 0 : 300);
        
        if (elIsClosed && el[0].tagName === 'FORM' && t.attr('data-reset-form') === 'true') {
            el[0].reset();
            // Clear filled values
            el.find('[data-reset-value]').each(function() {
                var it = $(this);
                if (this.tagName === 'INPUT' || this.tagName === 'SELECT') {
                    it.val(it.attr('data-reset-value'));
                } else {
                    it.html(it.attr('data-reset-value'));
                }
            });
        }
        
        if (togglers.length) {
            if (togglers.filter(':checked').length) {
                togglers.removeClass('required').addClass('derequired');
            } else {
                togglers.removeClass('derequired').addClass('required');
            }
        }

        if ((!togId || togId === '') && this.type !== 'checkbox' && this.type !== 'radio') {
            if (el.css('display') !== 'none' && el.find('.required').length) {
                el.find('.required').removeClass('required').addClass('derequired');
            } else if (elIsClosed && el.find('.derequired').length) {
                el.find('.derequired').removeClass('derequired').addClass('required');
            }
            if (!closeAll) {
                el.slideToggle();
                
                if (elIsClosed) {
                    t.addClass('toggled');
                } else {
                    t.removeClass('toggled');
                }
            }
        } else {
            el.each(function() {
                var $_ = $(this);
                if (this.getAttribute('data-toggle-id') === togId) {
                    if (t.hasClass('toggle-trigger-on')) {
                        if (!closeAll) $_.slideDown();
                        $_.find('.derequired').removeClass('derequired').addClass('required');
                    } else if (t.hasClass('toggle-trigger-off')) {
                        $_.slideUp();
                        $_.find('.required').removeClass('required').addClass('derequired');
                    } else if (t.prop('checked')) {
                        if (!closeAll) $_.slideDown();
                        $_.find('.derequired').removeClass('derequired').addClass('required');
                    } else if (t.hasClass('select-toggle-element')) {
                        var offValue = t.attr('data-toggle-off-value');
                        var onValue = t.attr('data-toggle-on-value');
                        
                        if (onValue && !offValue || offValue && offValue === t.val()) {
                            $_.slideUp();
                            $_.find('.required').removeClass('required').addClass('derequired');
                        } else if (offValue && !onValue || onValue && onValue === t.val()) {
                            $_.slideDown();
                            $_.find('.derequired').removeClass('derequired').addClass('required');
                        }
                    } else {
                        $_.slideToggle();
                        if ($_.css('display') === 'none') {
                            $_.find('.required').removeClass('required').addClass('derequired');
                        } else {
                            $_.find('.derequired').removeClass('derequired').addClass('required');
                        }
                    }
                } else {
                    $_.slideUp();
                    $_.find('.required').removeClass('required').addClass('derequired');
                }
            });
        }
	};
    
    var toggleCloseElement = function() {
        var $el = $(this).closest('.element-to-toggle');
        if (!$el[0]) {
            $el = $(this).closest('.toggle-outer-ctn').find('.element-to-toggle');
        }
        $el.slideUp();
    };

	var toggleVal = function() {
		var t = $(this);
		var el = t.closest('.toggle-val-ctn').find('.val-to-toggle');
		var val = t.val();

		if (t.attr('type') === 'checkbox') {
			val = t.prop('checked').toString();
		}

		el.val(val);
	};

	var checkSubmitForm = function(e) {
		if(e.which == 10 || e.which == 13) {
			e.preventDefault();
			$(this).closest('form').find('.form-submit-btn, .validate-form-btn, .trigger-form-btn').trigger('click');
		}
	};

	var typeNumbersOnly = function(e) {
		if (!e.shiftKey && (e.which === 0 || e.which === 8 || e.which === 48 || e.which === 49 || e.which === 50 || e.which === 51 || e.which === 52 || e.which === 53 || e.which === 54 || e.which === 55 || e.which === 56 || e.which === 57)) {
			return true;
		} else {
			e.preventDefault();
			return false;
		}
	};

	var typePricesOnly = function(e) {
		var k = e.which || e.keyCode || e.charCode;
		// Allow: BACKSPACE, TAB, ESCAPE, END, HOME, ARROWS, ., DELETE, NUMLOCK
		// Allow: Ctrl+A, Ctrl+C, Ctrl+X, Ctrl+V, Ctrl+Z, Ctrl+Y
		if ([0, 8, 9, 27, 35, 36, 37, 38, 39, 40, 46, 110, 144].indexOf(k) > -1
				|| [65, 67, 86, 88, 89, 90].indexOf(k) > -1 && (e.ctrlKey || e.metaKey)) {
			// Prevent more than 1 decimal point
			// keypress single quote is 39 and n is 110
			if (k === 46 && this.value.indexOf(".") > -1 
                    || [39, 110].indexOf(k) > -1 && e.type === "keypress") {
				e.preventDefault();
			} else {
				return;
			}
		}
		// Ensure that it is a number and stop the keypress
		if ((e.shiftKey || (k < 48 || k > 57)) && 
				((k < 96 || k > 105) || e.type === "keypress")) {
			e.preventDefault();
		}
	};
	
	var settingsInputChange = function(e) {
		var t = $(this);
        if (t.hasClass('settings-no-save')) {
            return;
        }
        
		var ctn = t.closest('.settings-ctn');
		if (ctn === undefined) {
			ctn = t.closest('.settings-master');
		}
		var label = t.attr('name');
		var val = t.val();
		var langs = t.attr('data-lang') ? t.attr('data-lang') : $('html').attr('data-all-langs');
		var element = $('.' + label);
		var extraClasses = '';

		if (t.attr('type') === 'checkbox') {
			val = t.prop('checked').toString();

			if (t.hasClass('no-false') && t.prop('checked') === false) {
				val = '';
			}
		}
        
		if (t.attr('multiple') !== undefined) {
			val = t.val() instanceof Array ? t.val().join(',') : t.val();
		}

		if (ctn.hasClass('settings-ctn')) {
			if (t.hasClass('text')) {
				ctn.find('input.text').each(function() {
					if ($(this).prop('checked')) {
						extraClasses += $(this).val() + ' ';
					}
				});
			} else if (t.hasClass('bg')) {
				ctn.find('input.bg').each(function() {
					if ($(this).prop('checked')) {
						extraClasses += $(this).val();
					}
				});
			} else if (t.hasClass('button')) {
				ctn.find('input.button').each(function() {
					if ($(this).prop('checked')) {
						extraClasses += $(this).val();
					}
				});
			}

			element.each(function() {
				$(this).removeClass();
				$(this).addClass($(this).attr('data-class')).addClass(extraClasses);
			});
		}

		updateLabelLangs(label, val, langs, function() {
			if (t.hasClass('refresh')) {
				refresh();
			}
		}, true);
	};

	var updateBgPosLabel = function() {
		var t = $(this);
		var value = t.val() + "%";
		var key = t.data('key');

		var langs = $('html').attr('data-all-langs');
		updateLabelLangs(key, value, langs, function() {}, true);
	};

	var changeBgPos = function() {
		var t = $(this);
		var ctn = $('.background-img-' + t.attr('data-id'));
		var currentPosition = ctn.css('backgroundPosition');
		var value = t.val();
		var otherVal;

		// change background
		if (t.hasClass('horizontal')) {
			otherVal = currentPosition.split('% ');
			ctn.css('backgroundPosition', value + '% ' + otherVal[1]);
		} else if (t.hasClass('vertical')) {
			otherVal = currentPosition.split(' ');
			ctn.css('backgroundPosition', otherVal[0] + ' ' + value + '%');
		}
	};

    var changeComponentImageSize = function (e) {
        var inp = e.target || this;
        var val = inp.value;

        if (!val.match(/(px|rem|em|pt|vh|vw)/i)) {
            // Not a valid height property
            return;
        }
        
        updateLabelLangs(inp.name, val, $('html').attr('data-all-langs'), voidAjax, true);
        $('.height-' + inp.getAttribute('data-id')).css('min-height', val);
    };

	var checkPageHeight = function() {
		setTimeout(function() {
			var offset = scrollTopBtn.offset().top;

			if (offset < $(window).height()) {
				scrollTopBtn.fadeOut();
			}
		}, 20);
	};

	var toggleInput = function() {
		var t = $(this);
		var id = t.attr('data-id');
		var form = t.closest('form');

		if (t.prop('checked')) {
			form.append('<input type="hidden" name="' + id + '" value="true"/>');
		} else {
			form.find('input[name=' + id + ']').remove();
		}
	};

	var closeOpenSettings = function() {
		var t = $(this);
		var compId = t.closest('.componentContainerDiv').attr('id');

		if (!t.hasClass('component-settings-close-btn')) {
			$('.settings-ctn').each(function() {
				if ($(this).closest('.componentContainerDiv').attr('id') !== compId || ($(this).closest('.componentContainerDiv').attr('id') !== null && compId === null)) {					
					$(this).slideUp();
				}
			});
		}
	};
    
    var updateLabelOnChange = function(e) {
        var $it = $(this);
        var val = this.checked ? 'true' : '';
        
        if ($it.hasClass('all-langs')) {
            updateLabelLangs($it.attr('name'), val, $('html').attr('data-all-langs'), voidAjax, true);
        } else {
            updateLabel($it.attr('name'), val, voidAjax, true);
        }
    };
    
    var removeEmptyParams = function(e) {
        $(this).find('.filters-form-2-param').each(function() {
            if (this.value === '') this.name = '';
        });
        return true;
    };
    
    var sendAction = function(e) {
        var url = this.getAttribute('data-url');
        if (url && url !== '') {
            ajax(url, refresh, true);
        }
    };
    
    var escapeChars = function(str) {
        return str
                .replace(/�/g, "\xC0")
                .replace(/�/g, "\xC1")
                .replace(/�/g, "\xC2")
                .replace(/�/g, "\xC3")
                .replace(/�/g, "\xC4")
                .replace(/�/g, "\xC5")
                .replace(/�/g, "\xC6")
                .replace(/�/g, "\xC7")
                .replace(/�/g, "\xC8")
                .replace(/�/g, "\xC9")
                .replace(/�/g, "\xCA")
                .replace(/�/g, "\xCB")
                .replace(/�/g, "\xCC")
                .replace(/�/g, "\xCD")
                .replace(/�/g, "\xCE")
                .replace(/�/g, "\xCF")
                .replace(/�/g, "\xD0")
                .replace(/�/g, "\xD1")
                .replace(/�/g, "\xD2")
                .replace(/�/g, "\xD3")
                .replace(/�/g, "\xD4")
                .replace(/�/g, "\xD5")
                .replace(/�/g, "\xD6")
                .replace(/�/g, "\xD8")
                .replace(/�/g, "\xD9")
                .replace(/�/g, "\xDA")
                .replace(/�/g, "\xDB")
                .replace(/�/g, "\xDC")
                .replace(/�/g, "\xDD")
                .replace(/�/g, "\xDE")
                .replace(/�/g, "\xDF")
                .replace(/�/g, "\xE0")
                .replace(/�/g, "\xE1")
                .replace(/�/g, "\xE2")
                .replace(/�/g, "\xE3")
                .replace(/�/g, "\xE4")
                .replace(/�/g, "\xE5")
                .replace(/�/g, "\xE6")
                .replace(/�/g, "\xE7")
                .replace(/�/g, "\xE8")
                .replace(/�/g, "\xE9")
                .replace(/�/g, "\xEA")
                .replace(/�/g, "\xEB")
                .replace(/�/g, "\xEC")
                .replace(/�/g, "\xED")
                .replace(/�/g, "\xEE")
                .replace(/�/g, "\xEF")
                .replace(/�/g, "\xF0")
                .replace(/�/g, "\xF1")
                .replace(/�/g, "\xF2")
                .replace(/�/g, "\xF3")
                .replace(/�/g, "\xF4")
                .replace(/�/g, "\xF5")
                .replace(/�/g, "\xF6")
                .replace(/�/g, "\xF8")
                .replace(/�/g, "\xF9")
                .replace(/�/g, "\xFA")
                .replace(/�/g, "\xFB")
                .replace(/�/g, "\xFC")
                .replace(/�/g, "\xFD")
                .replace(/�/g, "\xFE")
                .replace(/�/g, "\xFF");
    };

    var sortResults = function(json, prop, asc) {
        json = json.sort(function (a, b) {
            if (asc) {
                return (a[prop].toLowerCase() > b[prop].toLowerCase()) ? 1 : ((a[prop].toLowerCase() < b[prop].toLowerCase()) ? -1 : 0);
            } else {
                return (b[prop].toLowerCase() > a[prop].toLowerCase()) ? 1 : ((b[prop].toLowerCase() < a[prop].toLowerCase()) ? -1 : 0);
            }
        });
        return json;
    };
    
    var appendElement = function(e) {
        const btn = $(e.currentTarget);
        const ctn = btn.closest('.append-element-ctn');
        const clone = ctn.find('.append-element-temp').clone(true);
        
        ctn.find('.append-element-wrap').append(clone);
        clone.attr('class', 'appended-element ' + clone.attr('data-replace-class'))
            .removeAttr('data-replace-class');
    };
    
    var deleteAppendedElement = function(e) {
        const btn = $(e.currentTarget);
        const item = btn.closest('.appended-element');
        
        if (!!item.attr('id')) {
            item.addClass('deleting')
                .find('.form-input').addClass('disabled').attr('tabindex', '-1');
            item.find('.append-element-deleting-input').val('true');
        } else {
            item.remove();
        }
    };
    
    var undoDeleteAppendedElement = function(e) {
        const btn = $(e.currentTarget);
        const item = btn.closest('.appended-element');
        
        item.removeClass('deleting')
            .find('.form-input').removeClass('disabled').removeAttr('tabindex');
        item.find('.append-element-deleting-input').val('');
    };

	var init = function (page) {
		formValidator = Fw.component.models().form;
		filtersForm = $('.filters-form');
		scrollTopBtn = $('.scrolltop-btn');
		validateFormBtn = $('.validate-form-btn');
		toggleTriggerBtn = $('.toggle-trigger-element');
		toggleTriggerVal = $('.toggle-trigger-val');
		toggleTriggerInput = $('.toggle-form-input');
		submitFormBtn = $('.form-submit-btn');
		numbersOnlyInput = $('input.numbers-only');
		priceOnlyInput = $('input.price-only');
		settingsInput = $('.settings-ctn input[type="radio"], .settings-ctn input[type="checkbox"], .settings-ctn input.save-data, .settings-ctn select.save-data, .settings-master input[type="radio"], .settings-master input[type="checkbox"], .settings-master input.save-data, .settings-master select.save-data');
		bgPosRange = $('.image-bg-pos');
		toggleSettingsBtn = $('.toggle-component-settings-btn');

		submitFormBtn.click(submitForm);
		filtersForm.find('select:not(.multi-filter-select)').change(submitForm);
		filtersForm.find('.multi-filter-select').change(submitMultiFilter);
		filtersForm.find('input[type=radio]').change(submitForm);
		scrollTopBtn.click(scrollUp);
		validateFormBtn.click(validateForm);
		toggleTriggerBtn.click(toggleElement);
		$('.select-toggle-element').change(toggleElement);
		$('.toggle-close-element').click(toggleCloseElement);
		toggleTriggerVal.change(toggleVal);
		toggleTriggerInput.change(toggleInput);
		numbersOnlyInput.keypress(typeNumbersOnly);
		priceOnlyInput.keypress(typePricesOnly);
		settingsInput.change(settingsInputChange);
		bgPosRange.on('change', updateBgPosLabel);
		bgPosRange.on('input', changeBgPos);
		toggleSettingsBtn.click(closeOpenSettings);
        $('.ajax-action').click(sendAction);

		if (scrollTopBtn.length) {
			checkPageHeight();
		}

		$('form:not(#mg2LoginForm):not(.checkout-form)').find('input').keypress(checkSubmitForm);
        
        $('.filters-form-2').on('submit', removeEmptyParams);
        
        $('.image-size-input').on('change', changeComponentImageSize);
        
        $('.update-label-on-change').on('change', updateLabelOnChange);
        
        $('.ajax-validate-form-and-reload-btn').on('click', ajaxValidateFormAndReload);
        
        $('.scroll-to-element').on('click', scrollToElement);
        
        $('.append-element-btn').click(appendElement);
        $('.append-element-delete').click(deleteAppendedElement);
        $('.append-element-undo-delete').click(undoDeleteAppendedElement);
	};

	Fw.component.export('tools', {
		init: init,
		ignoreUnusedStates: ignoreUnusedStates,
		validateForm: validateForm,
        escapeChars: escapeChars,
        sortResults: sortResults
	});
	
	$(window).ready(init);

})(jQuery);

